import React from 'react';
import { setModelsModalState, useModelsModalState } from '../../../../store/state';

const CollectBtnGroup = ({ collectOptions = [] }) => {
  const collectType = useModelsModalState('collectType');
  const sortTypeChange = (value) => {
    setModelsModalState({ collectType: value });
  };
  return (
    <div className="flex h-[30px] p-0.5 bg-[#f4f6f8] rounded">
      {collectOptions.map((item) => (
        <button
          key={item.value}
          disabled={item.value === collectType}
          onClick={() => sortTypeChange(item.value)}
          className="h-[26px] px-3 rounded-sm text-xs text-[#ADADAD] disabled:bg-white disabled:text-[#2d2d2d]"
        >
          {item.label}
        </button>
      ))}
    </div>
  );
};
export default CollectBtnGroup;
